@if (hasError) {
  <app-enroll-go-paperless [goPaperLessSignatureError]="hasError"> </app-enroll-go-paperless>
}
